import { useState, MouseEvent } from 'react';
import {
  RadioGroup, Radio, FormControl, Popover, FormControlLabel,
} from '@mui/material';
import { useRouter } from 'next/router';
import { updateRouterQuery } from 'lib/utils/filterUtils';
import Sort from '@mui/icons-material/Sort';

interface Props<T> {
  sortOptions: { [k in string]: string };
  defaultSort: T;
  sort?: T;
  extraOptions?: { [k in string]: string };
  size?: 'small' | 'medium';
}

export const SortFilter = <T extends string>({
  sortOptions, sort, defaultSort, extraOptions, size = 'small',
}: Props<T>) => {
  const router = useRouter();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const onChange = (s: string) => {
    if (s === defaultSort) {
      updateRouterQuery(router, { sort: [] });
    } else {
      updateRouterQuery(router, { sort: s });
    }
    onClose();
  };

  const className = size === 'small' ? 'btn-primary-outlined-xs' : 'btn-primary-outlined';
  const fontSize = size === 'small' ? 'small' : 'medium';
  return (
    <>
      <button
        type="button"
        onClick={onClick}
        className={`${className} uppercase whitespace-nowrap flex items-center`}
      >
        <Sort fontSize={fontSize} />
        <span className="ml-2">Sort</span>
      </button>
      <Popover
        id="sort-by"
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <FormControl>
          <RadioGroup
            aria-labelledby="sort-radio-group"
            name="sort-radio-group"
            value={sort || defaultSort}
            onChange={(e) => onChange(e.target.value)}
            className="w-full p-4"
          >
            {
              Object.keys(sortOptions).map(
                (key: string) => (
                  <FormControlLabel
                    key={key}
                    value={key}
                    control={<Radio />}
                    label={sortOptions[key]}
                  />
                ),
              )
            }
            {
              extraOptions && Object.keys(extraOptions).map(
                (key: string) => (
                  <FormControlLabel
                    key={key}
                    value={key}
                    control={<Radio />}
                    label={extraOptions[key]}
                  />
                ),
              )
            }
          </RadioGroup>
        </FormControl>
      </Popover>
    </>
  );
};
